import React from "react";
import { Redirect } from "react-router";

import MainContainer from "../containers/MainContainer";
import LiveContainer from "../containers/LiveContainer";
import { getLiveReloadRedirectTarget } from "../lib/LoginRecoveryPath";

const WebLivePage = ({ browserType, currentPageType, isLoginYn, isJoinLive, isMixedClassMember, cookies, routeProps }) => {
    // console.log("WebLivePage - currentPageType => ", currentPageType, ", isMixedClassMember => ", isMixedClassMember);

    if (isLoginYn === "N") {
        // 20261020 R-126(Q-019): 새로고침·재기동으로 로그인 상태 없이 열린 경우, 들어온 로그인 페이지로 보낸다.
        // (RabbitmqClient 의 페이지 종류·연결 끊김 이동 규칙으로 저장한 경로. 없으면 기존처럼 /main)
        return <Redirect to={getLiveReloadRedirectTarget()} />;
    }

    return (
        <MainContainer 
            browserType={browserType} 
            cookies={cookies} 
            currentPageType={currentPageType} 
            routeProps={routeProps}
        >
            {/* 20261023 MainContainer는 단일 자식만 받으므로 코덱 안내는 수업 내부 모달에서 처리한다. */}
            <LiveContainer
                routeProps={routeProps}
                cookies={cookies} 
                isJoinLive={isJoinLive}
                browserType={browserType}
                currentPageType={currentPageType}
            />
        </MainContainer>
    );
};

export default WebLivePage;
